/* WAVY-JADE-0926 | wavy-money.js
   ONE money formatter for every WAVY surface (contract 1: box, sheet, ATC, drawer, quick add, cards).
   Config comes from layout/theme.liquid, embedded BEFORE this script (main session):
     <script>window.wjMoneyCfg={format:{% if settings.currency_code_enabled %}{{ shop.money_with_currency_format | json }}{% else %}{{ shop.money_format | json }}{% endif %},withCode:{{ settings.currency_code_enabled | json }},currency:{{ cart.currency.iso_code | json }}};</script>
   Liquid prints the identical string with:
     {%- if settings.currency_code_enabled -%}{{ x | money_with_currency }}{%- else -%}{{ x | money }}{%- endif -%}
   so "$186.00 NZD" appears everywhere or nowhere.
   API: window.wjMoney.format(cents) -> string
        window.wjMoney.configure({format, withCode, currency})   (re-read the config, e.g. after a Markets switch)
        window.wjMoney.parse(str) -> cents | null                   (inverse of format, for cross-checks)
        window.wjMoney.cfg() -> the active config
   No Liquid in here; no DOM needed. Safe to load on every page, before wavy-bogo.js / wavy-cart-pair.js. */
(function () {
  'use strict';
  if (window.wjMoney) return;

  var cfg = { format: '', withCode: false, currency: '' };
  var TOKEN = /\{\{\s*(\w+)\s*\}\}/;

  function stripTags(s) { return String(s || '').replace(/<[^>]*>/g, ''); }
  function activeCurrency() {
    return cfg.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
  }
  function configure(c) {
    c = c || {};
    if (typeof c.format === 'string') cfg.format = c.format;
    if (typeof c.withCode === 'boolean') cfg.withCode = c.withCode;
    if (typeof c.currency === 'string' && c.currency) cfg.currency = c.currency.toUpperCase();
    okCache = {};
  }

  /* number with thousands / decimal separators */
  function group(cents, dec, th, dp) {
    var parts = (Math.abs(cents) / 100).toFixed(dec).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
    return (cents < 0 ? '-' : '') + whole + (parts[1] ? dp + parts[1] : '');
  }
  var SPECS = {
    amount: [2, ',', '.'],
    amount_no_decimals: [0, ',', '.'],
    amount_with_comma_separator: [2, '.', ','],
    amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_apostrophe_separator: [2, "'", '.'],
    amount_no_decimals_with_space_separator: [0, ' ', ''],
    amount_with_space_separator: [2, ' ', ','],
    amount_with_period_and_space_separator: [2, ' ', '.']
  };

  /* Does the format already print the active currency (code, symbol or narrow symbol)? A stale format for
     another currency falls back to Intl so the shopper never sees "$" against NZD amounts. */
  var okCache = {};
  function formatMatches(fmt) {
    var cur = activeCurrency();
    if (!cur) return true;
    var key = cur + '|' + fmt;
    if (okCache[key] !== undefined) return okCache[key];
    var plain = stripTags(fmt), ok = plain.indexOf(cur) > -1;
    ['symbol', 'narrowSymbol'].forEach(function (disp) {
      if (ok) return;
      try {
        new Intl.NumberFormat('en', { style: 'currency', currency: cur, currencyDisplay: disp }).formatToParts(1).forEach(function (p) {
          if (p.type === 'currency' && plain.indexOf(p.value) > -1) ok = true;
        });
      } catch (e) { ok = true; }
    });
    okCache[key] = ok;
    return ok;
  }
  function intlFormat(cents) {
    var cur = activeCurrency() || 'USD', s;
    try { s = new Intl.NumberFormat('en', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { s = (cents / 100).toFixed(2); }
    if (cfg.withCode && s.indexOf(cur) === -1) s += ' ' + cur;
    return s;
  }

  function format(cents) {
    cents = Math.round(Number(cents) || 0);
    var fmt = cfg.format;
    if (!fmt || !formatMatches(fmt)) return intlFormat(cents);
    var m = fmt.match(TOKEN);
    if (!m) return stripTags(fmt);
    var spec = SPECS[m[1]] || SPECS.amount;
    return stripTags(fmt.replace(m[0], group(cents, spec[0], spec[1], spec[2]))).trim();
  }

  /* inverse: "$1,234.50 NZD" -> 123450 (uses the format's separators; null when no number is present) */
  function parse(str) {
    var m = (cfg.format || '').match(TOKEN), spec = SPECS[(m && m[1]) || 'amount'] || SPECS.amount;
    var s = String(str || '').replace(/[^\d.,'\s-]/g, '').trim();
    if (!s) return null;
    if (spec[1]) s = s.split(spec[1]).join('');
    if (spec[2] && spec[2] !== '.') s = s.replace(spec[2], '.');
    s = s.replace(/\s/g, '');
    var n = parseFloat(s);
    if (isNaN(n)) return null;
    return Math.round(n * 100);
  }

  configure(window.wjMoneyCfg);
  /* late config (a script tag or JSON block rendered after this file) */
  if (!cfg.format) {
    var el = typeof document !== 'undefined' && document.querySelector && document.querySelector('script[data-wj-money-cfg]');
    if (el) { try { configure(JSON.parse(el.textContent)); } catch (e) {} }
  }

  window.wjMoney = {
    version: 'WAVY-JADE-0926',
    format: format,
    parse: parse,
    configure: configure,
    cfg: function () { return { format: cfg.format, withCode: cfg.withCode, currency: activeCurrency() }; }
  };
})();
